exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6b5395e6] .el-dialog__body{padding-bottom:0}[data-v-6b5395e6] .el-scrollbar__wrap{padding-right:0}.el-dialog .model-confirm[data-v-6b5395e6]{display:flex;flex-wrap:wrap;justify-content:center;width:100%;height:0.78125rem;overflow:hidden}.el-dialog .model-confirm .success-img[data-v-6b5395e6]{width:auto;height:0.67708rem}.el-dialog .model-confirm p[data-v-6b5395e6]{width:100%;font-weight:600;font-size:0.07292rem;text-align:center;color:#000}\n", ""]);

// exports
